export default (locale: string) => {
  const org = (process.env.REACT_APP_ORG_NAME_SHORT || 'vid').toLowerCase();
  const product = process.env.REACT_APP_PROFILING?.toLowerCase();
  const suffix = locale === 'en' ? 'gb-en' : 'nb-no';

  // Dynamic pathing for Webpack context
  const base = require(`../languages/languages.${suffix}.json`);

  const specificFileName = product 
    ? `languages.${org}.${product}.${suffix}.json`
    : `languages.${org}.${suffix}.json`;

  let specific = {};
  try {
    // Dynamic pathing for Webpack context
    specific = require(`../languages/${specificFileName}`);
  } catch (e) {
    console.warn(`Translation file not found: ${specificFileName}`);
  }

  return { ...base, ...specific };
};